import { useEffect } from 'react';
import { createGlobalState } from './createGlobalState';
import useSessionStorage from 'react-use/lib/useSessionStorage';

const { useWithState, useDispatch, useState } = createGlobalState<boolean, {}>(p => !p, true);

const SIDEBAR_VISIBILITY_KEY = 'jp.tier4.drive.autoware.sidebar.visible';

export function useToggleSidebarVisibility() {
    const dispatch = useDispatch();

    const current = useState();
    const [stored, set] = useSessionStorage<boolean>(SIDEBAR_VISIBILITY_KEY);
    useEffect(() => {
        if (current == stored) return;
        set(current);
    }, [current, stored, set]);

    return () => dispatch({});
}

export function useSidebarVisibility() {
    return useState();
}

export function useWithSidebarVisibility() {
    const [value] = useSessionStorage<boolean>(SIDEBAR_VISIBILITY_KEY, true);

    return useWithState(() => value);
}
